export const getIsLoading = state => state.main.isLoading;
export const getJumbotron = state => state.main.textData.jumbotron;
export const getDescription = state => state.main.textData.description;
export const getServices = state => state.main.textData.services;
export const getCooperation1 = state => state.main.textData.cooperation1;
export const getCooperation2 = state => state.main.textData.cooperation2;
export const getSummary = state => state.main.textData.summary;
export const getContact = state => state.main.textData.contact;



// WEBPACK FOOTER //
// ./src/selectors/main.js